import React from "react";
import { useTranslation } from "react-i18next";
import { ChatHeaderStyle, StartNewConversationButton, HeaderTextStyle } from "./Styles";
import { Space, Row, Typography } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { AITeamMateTitle } from "./AITeamMateTitle";

const { Text } = Typography;

const HeaderText = ({ collapsed, t }) => (
  <Space direction={collapsed ? "horizontal" : "vertical"} size={collapsed ? 5 : 10}>
    <div style={{ width: collapsed ? "40vw" : undefined }}>
      <HeaderTextStyle
        style={{
          fontWeight: "600"
        }}
      >
        {t("ai_chat_bot.you_are_getting_early_look")}
      </HeaderTextStyle>
      <HeaderTextStyle>{t("ai_chat_bot.we_are_continuously_refining_and_expanding_its_capabilities")}</HeaderTextStyle>
    </div>
  </Space>
);

const NewChatButton = ({ collapsed, onNewChat, t }) => (
  <StartNewConversationButton
    style={{
      width: collapsed ? "auto" : "100%",
      marginRight: collapsed ? "5px" : "0",
      marginTop: collapsed ? "0" : "10px"
    }}
    type="text"
    onClick={onNewChat}
  >
    <Text style={{ color: "white" }}>{t("ai_chat_bot.new_chat")}</Text>
    <PlusCircleOutlined style={{ position: "relative", top: "1px" }} />
  </StartNewConversationButton>
);

const ChatHeader = ({ onNewChat, collapsed }) => {
  const { t } = useTranslation();

  if (collapsed)
    return (
      <ChatHeaderStyle collapsed={collapsed}>
        <Row justify="space-between" align="middle" style={{ width: "100%", lineHeight: "1.5", padding: "0 15px" }}>
          <Space size={15}>
            <AITeamMateTitle />
            <HeaderText collapsed={collapsed} t={t} />
          </Space>

          <NewChatButton collapsed={collapsed} onNewChat={onNewChat} t={t} />
        </Row>
      </ChatHeaderStyle>
    );

  return (
    <ChatHeaderStyle collapsed={collapsed}>
      <Row justify="center" style={{ width: "100%", lineHeight: "1.5" }}>
        <Space justify="space-between" direction={"vertical"} size={10}>
          <AITeamMateTitle />
          <HeaderText collapsed={collapsed} t={t} />

          <NewChatButton onNewChat={onNewChat} t={t} />
        </Space>
      </Row>
    </ChatHeaderStyle>
  );
};
export { ChatHeader };
